<template>
  <list-expansion
    v-if="obj"
    v-model="obj"
    :components="componentsItem"
    :disabled="loading"
    @save-required="$emit('save-required')"

  />
</template>

<script>
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import { mapState } from "vuex";

export default {
  name: "qrAppointmentManager",

  components: { ListExpansion },

  props: {
    value: Object,
    loading: Boolean,
  },

  data: () => ({
    componentsItem: [
      {
        name: "manageGateways",
        value: "",
        title: "درگاه پرداخت",
        subtitle: "",
        icon: "credit-card-settings-outline",
        model: "gateways",
      },
      {
        name: "appointmentReserveManager",
        value: "",
        title: "تنظیمات رزرو نوبت",
        subtitle: "",
        icon: "credit-card-settings-outline",
        model: "reserveManage",
      },
      {
        name: "orderNotices",
        value: "",
        title: "اطلاع رسانی سفارشات",
        subtitle: "",
        icon: "bell-outline",
        model: "notice",
      },
    ],
    obj: {
      reserveManage: {
        vat: 10,
        online_pay: 1,
        pay_in_person_place: 1,
        send_appointment_sms: 0,
      },
      notice: {
        phones: [{ number: "", id: null }],
      },
    },
  }),

  computed: {
    ...mapState("localstorage", ["createQrID"]),
  },

  methods: {
    fetchSettings() {
      this.computedLoading = true;

      this.$api
        .get(`/v1/testQr/setting/${this.createQrID}`)
        .then(({ data }) => {
          this.obj.reserveManage = {
            ...data.data,
            send_appointment_sms: data.data.send_appointment_sms ?? 0,
          };
        })
        .catch(({ response }) =>
          console.log("failed to get qr settings: ", response),
        )
        .finally(() => (this.computedLoading = false));
    },
    fetchNumbers() {
      this.computedLoading = true;

      this.$api
        .get("/v1/testQr/QrCodeNumber", {
          params: {
            qr_id: this.createQrID,
          },
        })
        .then(
          ({ data }) =>
            (this.obj.notice.phones[0] = {
              number: data?.data[0]?.number,
              id: data?.data[0]?.id,
            }),
        )
        .finally(() => (this.computedLoading = false));
    },
    setCartSetting() {
      return new Promise((resolve, reject) => {
        this.errors = {};
        let obj = this.obj.reserveManage;
        obj.qr_code_id = this.createQrID || 1;

        this.$api
          .post("/v1/testQr/setting", obj)
          .then((data) => {
            resolve("resolved");
          })
          .catch(({ response }) => {
            if (
              !!response?.data?.errors &&
              !!Object.keys(response.data.errors).length
            )
              this.$toast.error("مقادیر را به درستی وارد نمایید!");
            else this.$toast.error("تنظیمات سبد خرید با خطا مواجه شد!");
            console.log(response);
            reject("rejected");
          });
      });
    },
    setShopNotice() {
      return new Promise((resolve, reject) => {
        let number = this.obj.notice.phones[0]?.number;
        let id = this.obj.notice.phones[0]?.id;
        if (!number) return reject("rejected");

        this.errors = {};

        this.$api
          .post("/v1/testQr/QrCodeNumber", {
            // qr_code_number_id: this.createQrID,
            number: number,
            qr_code_number_id: id,
            qr_id: this.createQrID,
          })
          .then((data) => {
            resolve("resolved");
          })
          .catch(({ response }) => {
            if (
              !!response?.data?.errors &&
              !!Object.keys(response.data.errors).length
            )
              this.$toast.error("مقادیر را به درستی وارد نمایید!");
            else this.$toast.error("تنظیمات سبد خرید با خطا مواجه شد!");
            reject("rejected");
          });
      });
    },
  },
};
</script>

<style scoped></style>
